export default "__VITE_ASSET__b507ab16__"